import styled, { css } from 'styled-components';
import Currency from '../../../../shared/components/Currency';

export default {
  TableWrapper: styled.div<any>`
    padding: 8px 0 0;
    background-color: ${({ theme }) => theme.backgroundColor || '#f5f5f5'};
    padding-bottom: ${(props) => props.offset + 100}px;
  `,
  MobileCount: styled.div`
    opacity: 0.64;
    font-size: 12px;
    margin-top: 2px;
  `,
  CellInner: styled.div`
    text-align: center;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    ${(props) =>
      props.theme.isRtl &&
      css`
        align-items: flex-start;
      `}
  `,
  PriceColumn: styled.td`
    text-align: right;
  `,

  StyledCurrency: styled(Currency)`
    font-size: 14px;
  `,
};
